import { defineComponent, useCssVars, createElementBlock, createCommentVNode, openBlock, normalizeClass, createStaticVNode, createElementVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "loader-wrapper"
};
const _hoisted_2 = {
  key: 0,
  class: "circular-loader"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "FlowLoader",
  props: {
    loaderState: {},
    size: { default: "24px" },
    isLoading: { type: Boolean }
  },
  setup(__props) {
    useCssVars((_ctx) => ({
      "65d9d974": _ctx.size
    }));
    return (_ctx, _cache) => {
      var _a, _b, _c, _d, _e;
      return _ctx.loaderState || _ctx.isLoading ? (openBlock(), createElementBlock("div", _hoisted_1, [
        (openBlock(), createElementBlock("svg", {
          class: normalizeClass(["svg-loader", {
            "icon-is-valid": (_a = _ctx.loaderState) == null ? void 0 : _a.valid,
            "icon-is-invalid": (_b = _ctx.loaderState) == null ? void 0 : _b.invalid
          }]),
          viewBox: "0 0 100 100",
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink"
        }, [
          _cache[0] || (_cache[0] = createStaticVNode('<path class="svg-path svg-check-mark" d="m 0 60 l 30 30 l 70 -80" data-v-0fab9a31></path><path class="svg-path svg-x-mark" d="m 50 50 l 40 -40" data-v-0fab9a31></path><path class="svg-path svg-x-mark" d="m 50 50 l 40 40" data-v-0fab9a31></path><path class="svg-path svg-x-mark" d="m 50 50 l -40 -40" data-v-0fab9a31></path><path class="svg-path svg-x-mark" d="m 50 50 l -40 40" data-v-0fab9a31></path>', 5)),
          _ctx.isLoading || ((_c = _ctx.loaderState) == null ? void 0 : _c.isLoading) ? (openBlock(), createElementBlock("g", _hoisted_2, [
            createElementVNode("circle", {
              class: normalizeClass(["loader-path", {
                "loader-path-off": ((_d = _ctx.loaderState) == null ? void 0 : _d.valid) || ((_e = _ctx.loaderState) == null ? void 0 : _e.invalid)
              }]),
              cx: "50",
              cy: "50",
              fill: "none",
              r: "20",
              "stroke-width": "2"
            }, null, 2)
          ])) : createCommentVNode("", true)
        ], 2))
      ])) : createCommentVNode("", true);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=FlowLoader.vue2.js.map
